import { createSlice } from "@reduxjs/toolkit";
import { AuthState } from "../types";
import { doChangePassword, doLogin, doVerifyAdminPassword } from "./auth.action";
import { setHeaderAuthorization } from "src/services/api";

const initialState: AuthState = {
  admin: null,
  token: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // for logout
    resetAuthState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // login
      .addCase(doLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(doLogin.fulfilled, (state, action) => {
        const { data } = action.payload;
        const {
          authentication,
          uid,
          email,
          password,
          fullName,
          username,
          profilePic,
        } = data;

        state.admin = { uid, email, password, fullName, username, profilePic };
        state.token = authentication?.accessToken || null;
        state.isLoading = false;
        state.isAuthenticated = true;

        if (authentication?.accessToken) {
          setHeaderAuthorization(authentication.accessToken);
          localStorage.setItem("token", authentication?.accessToken);
        }
      })
      .addCase(doLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });

    // change password
    builder
      .addCase(doChangePassword.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(doChangePassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(doChangePassword.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(doVerifyAdminPassword.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(doVerifyAdminPassword.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(doVerifyAdminPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetAuthState } = authSlice.actions;
export default authSlice.reducer;
